export class FuncionarioTarefa {
    Id: number;
    TarefaId: number;
    FuncionarioId: number;
    Funcao:string = "";
}
